import React from 'react';
import AddIcon from '@wix/da-ds/pkg/Icons/Add';
import { useTranslation } from 'react-i18next';
import InnerMediaSelector from '../InnerMediaSelector';
import Button from '../../../Button';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import PlusIconWithTextButton from '../PlusIconWithTextButton';
import { MediaSourceType } from '../../types';
import s from './AddDeviationsButton.scss';
export var AddDeviationsButton = function (_a) {
    var buttonView = _a.buttonView, disabled = _a.disabled, limit = _a.limit, plusOnly = _a.plusOnly, currentDeviationIds = _a.currentDeviationIds, isShowingAddDeviationsPopup = _a.isShowingAddDeviationsPopup, showAddDeviationsPopup = _a.showAddDeviationsPopup, hideAddDeviationsPopup = _a.hideAddDeviationsPopup, addDeviationsAction = _a.addDeviations;
    var currentMediaSource = useCurrentMediaSource().currentMediaSource;
    var t = useTranslation().t;
    var onSelect = function (deviations) {
        addDeviationsAction(deviations);
        hideAddDeviationsPopup();
    };
    return (React.createElement(React.Fragment, null,
        plusOnly ? (React.createElement(Button, { view: buttonView, onClick: showAddDeviationsPopup, disabled: disabled, className: s['add-button'] },
            React.createElement(AddIcon, { className: s['add-icon'] }))) : (React.createElement(PlusIconWithTextButton, { buttonView: buttonView, onClick: showAddDeviationsPopup, disabled: disabled, text: t(currentMediaSource === MediaSourceType.TIER_POSTS
                ? 'mediapopup.addPosts'
                : 'mediapopup.addDeviations') })),
        isShowingAddDeviationsPopup && (React.createElement(InnerMediaSelector, { onSelect: onSelect, onClose: hideAddDeviationsPopup, selectionLimit: limit, title: t(currentMediaSource === MediaSourceType.TIER_POSTS
                ? 'mediapopup.addPosts'
                : 'mediapopup.addDeviations'), submitBtnLabel: t('mediapopup.add'), ignoreDeviationIds: currentDeviationIds }))));
};
AddDeviationsButton.displayName = 'AddDeviationsButton';
export default AddDeviationsButton;
//# sourceMappingURL=AddDeviationsButton.js.map